// extracted by mini-css-extract-plugin
export default {"plexus":"PlexusBackground_plexus__-lLLm"};